<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="12" v-if="this.$store.state.user.info.systemAdmin">
            <a-form-item label="水司">
              <a-select placeholder="请选择" default-value v-model="query.tenantId" allow-clear>
                <a-select-option
                  v-for="item in tenantList"
                  :key="item.tenantId"
                  :value="item.tenantId"
                >{{ item.tenantName }}</a-select-option>
                <a-select-option
                  v-for="item in tenantList"
                  :key="item.tenantId"
                  :value="item.tenantId"
                >{{ item.tenantName }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="位置">
              <a-input v-model="query.name" placeholder="请输入名字" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="类型">
              <a-select v-model="query.type" placeholder="请选择类型" allow-clear>
                <a-select-option :value="0">管径</a-select-option>
                <a-select-option :value="1">管材</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="addOrUpdateHandle()">新增</a-button>
              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()">删除</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      rowKey="id"
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
    >
      <span slot="action" slot-scope="text, record">
        <a @click="addOrUpdateHandle(record.id)">编辑</a>
        <!-- <a-divider type="vertical" /> -->
        <!-- <a @click="showLineLayer(record)">展示线</a> -->
      </span>
      <span slot="createTime" slot-scope="text">{{ moment(text).format("YYYY-MM-DD") }}</span>
      <span slot="typeAction" slot-scope="text">
        <a-tag v-if="text===1" color="#40a9ff">管材</a-tag>
        <a-tag v-if="text===0" color="#1890ff">管径</a-tag>
      </span>
    </a-table>
    <a-modal
      title="操作"
      style="top: 20px"
      :width="800"
      v-model="addOrUpdateVisible"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form class="log-form" :form="addOrUpdateForm">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="名称">
          <a-input
            placeholder="名称"
            v-decorator="['name', { rules: [{ required: true, message: '名称' }] }]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="个数">
          <a-input
            placeholder="个数"
            v-decorator="['proportion', { rules: [{ required: true, message: '个数' }] }]"
          />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="类型"
        >
          <a-select v-decorator="['type',{ rules: [{ required: true, message: '请选择类型' }] }]">
            <a-select-option :value="1">管材</a-select-option>
            <a-select-option :value="0">管径</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
const columns = [
  {
    title: '名称',
    dataIndex: 'name'
  },
  {
    title: '个数',
    dataIndex: 'proportion'
  },
  {
    title: '类型',
    dataIndex: 'type',
    scopedSlots: { customRender: 'typeAction' }
  },
  {
    title: '操作',
    width: '150px',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  mixins: [mixinViewModule],
  name: 'MaintenanceIndicators',
  data () {
    return {
      currentId: '',
      queryUrl: '/pipe-network/maintenance_indicators/page',
      deleteUrl: '/pipe-network/maintenance_indicators',
      addOrUpdateUrl: '/pipe-network/maintenance_indicators',
      queryOneUrl: '/pipe-network/maintenance_indicators',
      mapVisible: false,
      query: {
        name: '',
        type: '',
        tenantId: this.$store.state.user.info.tenantId
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      columns,
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' })
    }
  },

  created () {
    this.getAllTenant()
  },
  methods: {
  },
  watch: {}
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>
